import { createContext, useContext } from "react";

import type { Preferences } from "@/lib/preferences";

export interface PreferencesContextValue {
  preferences: Preferences;
  setPreferences: (update: Partial<Preferences>) => void;
  resetPreferences: () => void;
}

export const PreferencesContext = createContext<PreferencesContextValue | null>(null);

export function usePreferences(): PreferencesContextValue {
  const ctx = useContext(PreferencesContext);
  if (!ctx) {
    throw new Error("usePreferences must be used inside <PreferencesProvider>");
  }
  return ctx;
}
